import { render, staticRenderFns } from "./DeleteEmail.vue?vue&type=template&id=6b4aeca3&scoped=true"
import script from "./DeleteEmail.vue?vue&type=script&lang=js"
export * from "./DeleteEmail.vue?vue&type=script&lang=js"
import style0 from "./DeleteEmail.vue?vue&type=style&index=0&id=6b4aeca3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4aeca3",
  null
  
)

export default component.exports